import { FC, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { addFrequencyAnswer, selectFrequencyAnswers } from '@/store/reducers/survey/surveySlice';
import FrequencyForm from '@/components/forms/FrequencyForm';
import WalletImage from '@/assets/images/wallet.png';
import useSurveyNavigate from '@/hooks/useSurveyNavigate';
import analytics from '@/utils/analytics/analyticsInstance';

const SpendingPage: FC = () => {
  const { next } = useSurveyNavigate();
  const dispatch = useAppDispatch();
  const answers = useAppSelector(selectFrequencyAnswers);
  const question = 'What’s your average monthly spend on online shopping?';

  const handleSubmit = (answer: string) => {
    dispatch(addFrequencyAnswer({ question, answer }));

    setTimeout(() => {
      next();
      analytics.track('webOnboardingQuestionAnswered', {
        question,
        answer,
      });
    }, 1000);
  };

  useEffect(() => {
    analytics.track('webOnboardingScreenOpened', {
      screen_title: question,
    });
  }, []);

  return (
    <FrequencyForm
      title={question}
      options={[
        { question: '1', answer: 'less than $100' },
        { question: '2', answer: '$100-200' },
        { question: '3', answer: '$200-400' },
        { question: '4', answer: 'more than $400' },
      ]}
      selectedAnswer={(answers[1]?.answer as string) || ''}
      image={WalletImage}
      onSelect={handleSubmit}
    />
  );
};

export default SpendingPage;
